





































import {Component, Vue} from "vue-property-decorator";
import DefaultTemplate from "@/components/templates/default/DefaultTemplate.vue";
import PrimaryBtn from "@/components/infrastructures/atoms/designed/PrimaryBtn.vue";
import HpTitle from "@/components/infrastructures/atoms/text/HpTitle.vue";
import HpText from "@/components/infrastructures/atoms/text/HpText.vue";
import authService from "@/components/domains/authorization/authService";
import PasswordlessService, {
  errorMessage,
  takeFragmentToken
} from "@/components/domains/account/passwordless/passwordlessService";

const NO_TOKEN = "このリンクは使えません。もう一度、メールアドレスの設定からやり直してください。";

/**
 * メールアドレス確認リンクの着地ページ（/mail-address/confirm#token=…）。ログインしていなくても使える。
 * 本人が頼んだ設定を、届いたメールボックスの持ち主が完了させるだけなので、開いたときに確定してよい。
 */
@Component({
  components: {DefaultTemplate, PrimaryBtn, HpTitle, HpText}
})
export default class MailAddressConfirmPage extends Vue {
  name = "MailAddressConfirmPage";

  phase: "working" | "done" | "failed" = "working";
  errorMsg = "";
  mailAddress = "";
  signedIn = false;
  private running = false;

  mounted() {
    this.run();
    window.addEventListener("hashchange", this.run);
  }

  beforeDestroy() {
    window.removeEventListener("hashchange", this.run);
  }

  async run() {
    const token = takeFragmentToken();
    if (!token && this.phase !== "working") {
      return; // 自分で消した # による呼び出し。新しいリンクではない。
    }
    if (this.running) {
      return;
    }
    this.running = true;
    this.phase = "working";
    try {
      await this.confirm(token);
    } finally {
      this.running = false;
    }
  }

  private async confirm(token: string) {
    if (!token) {
      this.errorMsg = NO_TOKEN;
      this.phase = "failed";
      return;
    }
    try {
      const res: any = await PasswordlessService.confirmMailAddress(token);
      this.mailAddress = res && res.data && typeof res.data.mailAddress === "string" ? res.data.mailAddress : "";
    } catch (e) {
      this.errorMsg = errorMessage(e, NO_TOKEN);
      this.phase = "failed";
      return;
    }
    this.phase = "done";
    // ログイン中なら最新の情報に更新する（「メールアドレスを設定してください」を消すため）。
    // 未ログインでもログイン画面へ飛ばされないよう、まず共通処理を通さずに確かめる。
    this.signedIn = await PasswordlessService.isSignedIn();
    if (this.signedIn) {
      await authService.authMe();
    }
  }
}
